module.exports = __webpack_public_path__ + "img/banano-bet-preview.b2590bb8c65ee22b13a19d50d9763c9a.jpg";